import { CaseFlowChangeReason } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const caseFlowChangeReasonMessages = defineMessages({
  bornIntoThread: {
    defaultMessage: 'Customer was already in a conversation',
    description: 'case flow change reason',
  },
  channelRefused: {
    defaultMessage: 'Messaging channel refused the conversation',
    description: 'case flow change reason',
  },
  escalationCase: {
    defaultMessage: 'Created from a conversation handover',
    description: 'case flow change reason',
  },
  existingConversation: {
    defaultMessage: 'Live conversation already open — opener skipped',
    description: 'case flow change reason',
  },
  noConsent: {
    defaultMessage: 'No recorded opt-in consent',
    description: 'case flow change reason',
  },
  noOpenerLadder: {
    defaultMessage: 'Campaign has no opener messages',
    description: 'case flow change reason',
  },
  noScreeningPlaybook: {
    defaultMessage: 'Campaign has no screening playbook',
    description: 'case flow change reason',
  },
  noSendChannel: {
    defaultMessage: 'Campaign has no send channel',
    description: 'case flow change reason',
  },
  noUsablePhone: {
    defaultMessage: 'No usable phone number on the case',
    description: 'case flow change reason',
  },
  numberNotReachable: {
    defaultMessage: 'Number is not reachable on WhatsApp',
    description: 'case flow change reason',
  },
  threadAlreadyEngaged: {
    defaultMessage: "Number's conversation belongs to another relationship",
    description: 'case flow change reason',
  },
  threadHeldByOtherCustomer: {
    defaultMessage: "Number's conversation belongs to a different customer",
    description: 'case flow change reason',
  },
})

export function translateCaseFlowChangeReason(
  intl: IntlShape,
  reason: CaseFlowChangeReason,
): string {
  switch (reason) {
    case CaseFlowChangeReason.BORN_INTO_THREAD:
      return intl.formatMessage(caseFlowChangeReasonMessages.bornIntoThread)
    case CaseFlowChangeReason.CHANNEL_REFUSED:
      return intl.formatMessage(caseFlowChangeReasonMessages.channelRefused)
    case CaseFlowChangeReason.ESCALATION_CASE:
      return intl.formatMessage(caseFlowChangeReasonMessages.escalationCase)
    case CaseFlowChangeReason.EXISTING_CONVERSATION:
      return intl.formatMessage(caseFlowChangeReasonMessages.existingConversation)
    case CaseFlowChangeReason.NO_CONSENT:
      return intl.formatMessage(caseFlowChangeReasonMessages.noConsent)
    case CaseFlowChangeReason.NO_OPENER_LADDER:
      return intl.formatMessage(caseFlowChangeReasonMessages.noOpenerLadder)
    case CaseFlowChangeReason.NO_SCREENING_PLAYBOOK:
      return intl.formatMessage(caseFlowChangeReasonMessages.noScreeningPlaybook)
    case CaseFlowChangeReason.NO_SEND_CHANNEL:
      return intl.formatMessage(caseFlowChangeReasonMessages.noSendChannel)
    case CaseFlowChangeReason.NO_USABLE_PHONE:
      return intl.formatMessage(caseFlowChangeReasonMessages.noUsablePhone)
    case CaseFlowChangeReason.NUMBER_NOT_REACHABLE:
      return intl.formatMessage(caseFlowChangeReasonMessages.numberNotReachable)
    case CaseFlowChangeReason.THREAD_ALREADY_ENGAGED:
      return intl.formatMessage(caseFlowChangeReasonMessages.threadAlreadyEngaged)
    case CaseFlowChangeReason.THREAD_HELD_BY_OTHER_CUSTOMER:
      return intl.formatMessage(caseFlowChangeReasonMessages.threadHeldByOtherCustomer)
  }
}
